import React from "react";
import "../../style/customslider.css";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

function Topartist() {
  const navigate = useNavigate();
  var settings = {
    // dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2.3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2.2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1.8,
        },
      },
      {
        breakpoint: 840,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.3,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 1.1,
        },
      },
    ],
  };

  const Topartist = () => {
    navigate("/all-topartist");
  };

  return (
    <div className="pt120 pb-3">
      <div className="topArtist">
        <div className="discription">
          <h3>top artists</h3>
          <div className="d-flex flex-column pt-md-3 pt-1">
            <span>JOLLY is the </span>
            <span>world's first and largest NFT</span>
            <span> marketplace</span>
          </div>
          <button
            className="mt-md-4 mt-2 all  border border-0"
            onClick={() => Topartist()}
          >
            See all
          </button>
        </div>

        <div className="carouselContainer">
          {/* <div className="carouselBox"> */}
          <Slider {...settings}>
            <div className="cardCarousel">
              <div>
                <img src="a2.png" alt="top" className="w-100 rounded" />
              </div>
              <div className="nameTop">
                <img
                  src="Screen Shot 2021-12-21 at 12.38 8.png"
                  alt="profile"
                  className="pe-2 profileArtist"
                />
                <h5>ApeYachtClub</h5>
                <img src="signed 1.png" alt="tick" className="tick ms-2" />
              </div>
            </div>
            <div className="cardCarousel">
              <div>
                <img src="a5.png" alt="top" className="w-100 rounded" />
              </div>
              <div className="nameTop">
                <img
                  src="Screen Shot 2021-12-21 at 12.37 8.png"
                  alt="profile"
                  className="pe-2 profileArtist"
                />
                <h5>DeGods</h5>
                <img src="signed 1.png" alt="tick" className="tick ms-2" />
              </div>
            </div>
            <div className="cardCarousel">
              <div>
                <img src="a4.png" alt="top" className="w-100 rounded" />
              </div>
              <div className="nameTop">
                <img
                  src="Screen Shot 2021-12-21 at 12.38 8.png"
                  alt="profile"
                  className="pe-2 profileArtist"
                />
                <h5>ApeYachtClub</h5>
                <img src="signed 1.png" alt="tick" className="tick ms-2" />
              </div>
            </div>
          </Slider>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export default Topartist;
